import { apiEndpoint } from '../../_config/config'
import { handleResponse } from '../../_helpers'
import axios from 'axios'

export const form = {
  namespaced: true,
  state: {
    form: {}
  },
  actions: {
    send ({ commit }, { data }) {
      commit('SEND_REQUEST')

      const config = {
        method: 'POST',
        url: `${apiEndpoint}/api/frontend/contact-form/new`,
        data: JSON.stringify(data)
      }

      axios(config).then(handleResponse).then((item) => {
        commit('SEND_SUCCESS', item)
      }).catch((error) => {
        commit('SEND_ERROR', error)
      })
    }
  },
  mutations: {
    SEND_REQUEST (state) {
      state.form = { saving: true }
    },
    SEND_SUCCESS (state) {
      // console.log('form succesfully submitted!')
      state.form = { send: true }
    },
    SEND_ERROR (state, error) {
      // console.log('form not succesfully submitted!')
      state.form = { send: false, error }
    }
  },
  getters: {
    noFormSendYet: state => {
      return (typeof state.form.saving === 'undefined' && typeof state.form.send === 'undefined')
    },
    sendingForm: state => {
      return (typeof state.form.saving !== 'undefined')
    },
    sendFormOk: state => {
      if (typeof state.form.send === 'undefined') {
        return false
      }

      return state.form.send
    }
  }
}
